<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="所属团队" prop="teamId">
						<el-select v-model="queryParams.teamId" style="width: 100%;" placeholder="请选择团队">
							<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="处理状态">
						<el-select v-model="queryParams.state" placeholder="请选择处理状态">
							<el-option label="全部" value=""></el-option>
							<el-option label="未处理" :value="0"></el-option>
							<el-option label="已处理" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="编号/名称"><el-input v-model="queryParams.keyword" placeholder="请输入求助设备编号/名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd">发起求助</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark">
					<el-table-column prop="id" label="序号" width="60">
						<template slot-scope="scope">
							{{scope.$index+1}}
						</template>
					</el-table-column>
					<el-table-column prop="orderNo" label="求助设备编号" width="180"></el-table-column>
					<el-table-column prop="deviceTitle" label="求助设备名称"></el-table-column>
					<el-table-column prop="title" label="求助描述"></el-table-column>
					<el-table-column prop="contact" label="联系方式"></el-table-column>
					<el-table-column prop="teamTitle" label="所属团队"></el-table-column>
					<el-table-column prop="creatorName" label="提交人"></el-table-column>
					<el-table-column prop="createTime" label="提交时间"></el-table-column>
					<el-table-column prop="state" label="状态">
						<template slot-scope="scope">
							{{scope.row.state | formatState}}
						</template>
					</el-table-column>
					<el-table-column prop="operatorName" label="处理人"></el-table-column>
					<el-table-column prop="operateTime" label="处理时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog title="发起求助" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false">
			<el-row>
				<div class="left"></div>
				<div class="center">
					<div>模块上有三盏灯</div><br />
					<div>通电后</div>
					<div style="color:#F56C6C">红框内应常亮</div>
					<div style="color:#67C23A">绿框内应常亮</div>
					<div>否则说明模块硬件有问题</div>
					<div style="color:#E6A23C">黄框内</div>
					<div style="color:#E6A23C">闪烁代表上网正常</div>
					<div style="color:#E6A23C">闪烁状态同时显示在控制面板</div>
					<div style="margin-top: 10px;">黄框内常亮和不亮都是上网异常</div>
					<div class="wifi"></div>
				</div>
				<div class="right">
					<el-form :inline="false" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px" :before-close="handleClose">
						<el-form-item label="所属团队" prop="teamId">
							<el-select v-model="addOrUpdateForm.teamId" style="width: 100%;" placeholder="请选择团队">
								<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="关联设备" prop="deviceId">
							<el-select v-model="addOrUpdateForm.deviceId" ref="deviceSelect" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
								:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true">
								<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="描述异常情况" prop="title">
							<el-input type="textarea" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title"></el-input>
						</el-form-item>
						<el-form-item label="联系方式" prop="contact"><el-input type="text" v-model="addOrUpdateForm.contact"></el-input></el-form-item>
						<el-form-item label="上传照片" prop="images">
							<el-upload :file-list="imageList" action="/api/system/file/upload" list-type="picture-card" :on-success="handleUploadSuccess" :before-upload="beforeUpload" 
								:headers="headers" :auto-upload="true">
								<i slot="default" class="el-icon-plus"></i>
								<div slot="file" slot-scope="{file}">
									<el-image style="width: 80px; height: 80px" :src="file.url" fit="fit"></el-image>
									<span class="el-upload-list__item-actions">
										<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
											<i class="el-icon-zoom-in"></i>
										</span>
										<span class="el-upload-list__item-delete" @click="handleRemove(file)">
											<i class="el-icon-delete"></i>
										</span>
									</span>
								</div>
							</el-upload>
						</el-form-item>
					</el-form>
				</div>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose()">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog title="查看求助" :visible.sync="dialogDetailVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="false" :model="addOrUpdateForm" ref="addOrUpdateForm" label-width="120px">
				<el-form-item label="所属团队" prop="teamId">
					<el-select :disabled="true" v-model="addOrUpdateForm.teamId" style="width: 100%;" placeholder="请选择团队">
						<el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关联设备" prop="deviceId">
					<el-select :disabled="true" v-model="addOrUpdateForm.deviceId" ref="deviceSelect" filterable remote reserve-keyword placeholder="请选择设备" :remote-method="queryDeviceList"
						:loading="deviceLoading" @focus="deviceSelectFocus" :clearable="true">
						<el-option v-for="item in deviceList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="描述异常情况" prop="title">
					<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.title"></el-input>
				</el-form-item>
				<el-form-item label="联系方式" prop="contact"><el-input :disabled="true" type="text" v-model="addOrUpdateForm.contact"></el-input></el-form-item>
				<el-form-item label="处理结果" prop="state">{{addOrUpdateForm.state | formatState}}</el-input></el-form-item>
				<el-form-item label="处理记录" prop="description">
					<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
				</el-form-item>
				<el-form-item label="上传照片">
					<span class="el-descriptions-item__content">
						<div>
							<ul class="el-upload-list el-upload-list--picture-card">
								<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
									<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
								</li>
							</ul>
						</div>
					</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogDetailVisible = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'mngr/maintenance/sim',
				name: 'SIM求助',
				teamList:[],
				deviceList:[],
				deviceLoading:false,
				dialogDetailVisible:false,
				imageList:[],
				queryDeviceParams: {
					currentPage: 1,
					pageSize: 10,
					defaultSort: {
						order: 'desc',
						prop: 'id'
					}
				},
				rules: {
					teamId: [{
							required: true,
							message: '请选择团队id',
							trigger: 'blur'
						}
					],
					title: [{
							required: true,
							message: '请输入描述异常情况',
							trigger: 'blur'
						},
						{
							max: 500,
							message: '描述长度最长支持500',
							trigger: 'blur'
						}
					],
					deviceId: [{
							required: true,
							message: '请选择关联设备',
							trigger: 'blur'
						}
					],
					contact: [{
							required: true,
							message: '请输入联系方式',
							trigger: 'blur'
						},
						{
							max: 500,
							message: '联系方式长度最长支持500',
							trigger: 'blur'
						}
					]
					
				}
			};
		},
		filters: {
			formatState(state) {
				if(state==0){
					return "未处理"
				}else{
					return "已处理"
				}
			}
		},
		methods: {
			handleDetail(row) {
				this.createUpdateForm(row);
				this.dialogDetailVisible = true;
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					this.addOrUpdateForm = newObj;
					this.deviceList=[{
						id:newObj.deviceId,
						title:newObj.deviceTitle,
					}]
				} else {
					this.addOrUpdateForm = {
						imageList:[]
					};
				}
			},
			handleClose(done){
				this.imageList=[]
				if(done){
					done();
				}else{
					this.dialogVisible = false
				}
			},
			handleUploadSuccess(res, file) {
				this.imageList.push(file);
				this.addOrUpdateForm.imageList.push(res.data);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogPreviewVisible = true;
			},
			handleRemove(file) {
				var index = this.imageList.findIndex(item => item.uid === file.uid)
				this.imageList.splice(index, 1);
			},
			beforeUpdate() {},
			queryTeamList() {
				this.$http({
					method: 'POST',
					url: 'team/query',
					data: {
						currentPage: 1,
						pageSize: 100,
						defaultSort: {
							order: 'desc',
							prop: 'id'
						}
					},
				}).then((res)=> {
					this.teamList = res.data.data;
				})
			},
			queryDeviceList(query) {
				this.deviceLoading = true;
				this.queryDeviceParams.title = query;
				this.$http({
					method: 'POST',
					url: 'devices/query',
					data: this.queryDeviceParams,
				}).then((res) =>{
					this.deviceList = res.data.data;
					this.deviceLoading = false
				})
			},
			deviceSelectFocus() {
				if(this.addOrUpdateForm.teamId){
					this.queryDeviceList()
				}else{
					this.$refs['addOrUpdateForm'].validateField('teamId',valid => {})
				}
				
			},
		},
		mounted: function() {
			this.queryTeamList()
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.left {
		background: url(../../../assets/img/left.png);
		background-size: 100% 100%;
		width: 340px;
		height: 320px;
		float: left;
	}

	.center {
		float: left;
		margin-left: 15px;
		width: 220px;
		text-align: center;
		font-size: 18px;
		margin-top: 15px;
		position: relative
	}

	.wifi {
		position: absolute;
		right: 40px;
		top: 244px;
		background: url(../../../assets/img/wifi.png);
		background-size: 100% 100%;
		width: 43px;
		height: 31px;
	}

	.right {
		float: left;
		width: 520px;
	}
	
	
	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}
	
	/deep/ .el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 90px;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/order/maintenanceSim.vue